export const PRODUCTS_PER_PAGE = 60;

export const TOTAL_PRODUCTS_WITH_EAGER_LOADING = 8;

/** Elevate flag id (in productFlags/variantFlags) marking a product as a fabric sample. */
export const SAMPLE_FLAG = "is_sample";
